import history from '../../containers/History'
import queryString from 'query-string'
import {
  changeAuthorizationType,
  authLoginSSO,
  clearState,
} from '../../containers/Auth'
import {
  updatePreviousLocation,
  getMe,
  updateCurrentTeamId,
} from '../../store/appReducer'
import {
  LOGIN_ERROR_MESSAGES,
  DATASOURCES,
  AUTHORIZATION_TYPES,
  CLEAR_STATE,
} from '../../constants'
import { clearAppState } from '../../../state/reducers/app/appActions'

// ------------------------------------
// Constants
// ------------------------------------
const PREFIX = 'LOGIN.'
export const LOGIN_REQUEST = `${PREFIX}LOGIN_REQUEST`
export const LOGIN_SUCCESS = `${PREFIX}LOGIN_SUCCESS`
export const LOGIN_FAILED = `${PREFIX}LOGIN_FAILED`
export const LOGIN_CANCELLED = `${PREFIX}LOGIN_CANCELLED`
export const UPDATE_LOGIN_ERROR = `${PREFIX}UPDATE_LOGIN_ERROR`
export const CLEAR_LOGIN_ERROR = `${PREFIX}CLEAR_LOGIN_ERROR`
export const UPDATE_LOGIN_FORM = `${PREFIX}UPDATE_LOGIN_FORM`
export const CLEAR_LOGIN_FORM = `${PREFIX}CLEAR_LOGIN_FORM`
export const LOGOUT = `${PREFIX}LOGOUT`

// ------------------------------------
// Actions
// ------------------------------------
export function requestLogin() {
  return {
    type: LOGIN_REQUEST,
  }
}
export function loginSuccess() {
  return {
    type: LOGIN_SUCCESS,
  }
}
export function loginFailed() {
  return {
    type: LOGIN_FAILED,
  }
}
export function loginCancelled() {
  return {
    type: LOGIN_CANCELLED,
  }
}
export function updateLoginError(errorMsg) {
  return {
    type: UPDATE_LOGIN_ERROR,
    payload: errorMsg,
  }
}

export function handleLogin(code, sso) {
  return (dispatch, getState) => {
    dispatch(requestLogin())

    // const creds = getState().login.form
    // const { username, password } = creds

    if (code && sso) {
      return dispatch(authLoginSSO({ code, sso })).then(() => {
        const { isAuthenticated, authError } = getState().auth
        // const isAuthenticated = dispatch(checkAuthentication())
        if (isAuthenticated) {
          return dispatch(getMe()).then(() => {
            const { [DATASOURCES.ME]: me } = getState().app.dataSources
            const { currentTeamId, previousLocation } = getState().app

            const qsParams = queryString.parse(window.location.search)
            const isPrevRelativePath = qsParams.prev
              ? qsParams.prev[0] === '/'
              : false

            let nextLocation

            dispatch(clearState())
            // for new framework app store data.
            dispatch(clearAppState())
            // console.log('SomeThings happening ==> ', qsParams)
            if (
              currentTeamId.length !== 0 &&
              me.data.teams[0].id !== currentTeamId
            ) {
              dispatch(updateCurrentTeamId(me.data.teams[0].id))
              dispatch(changeAuthorizationType(AUTHORIZATION_TYPES.PHYSICIAN))
            } else {
              nextLocation = previousLocation
            }

            // dispatch(clearLoginForm())
            dispatch(loginSuccess())

            if (isPrevRelativePath) {
              window.location.href = qsParams.prev
            } else if (!nextLocation) {
              history.push('/')
            } else {
              history.push(nextLocation)
            }
          })
        } else {
          dispatch(updateLoginError(authError))
          return dispatch(loginFailed())
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/legacy/pages/AppOrchard/module.js